import { useApolloClient, useQuery } from "@apollo/react-hooks";
import { image, productList } from "./commonList";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import _ from 'lodash';
import Swal from "sweetalert2";
import moment from "moment";
import validator from "validator";

export const GO_TO_THANK_YOU = "GO_TO_THANK_YOU";
export const MOVE_TO_NEXT = "MOVE_TO_NEXT";
export const UPDATE_JOURNEY = "UPDATE_JOURNEY";

export const wait = (time: any) => {
  return new Promise(resolve => setTimeout(resolve, time * 1000));
}

export const openPage = (url) => {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noreferrer noopener";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
// ! ---------------------------------------------------------------------------
// ! PDEAMS_FLAG
global.IS_PDEAMS_ACTIVE = true;
global.JAP_NIF = "506438694";


// * Always disable PDEAMS on production
const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
if (env == "production") {
  // global.IS_PDEAMS_ACTIVE = false; // ! DO NOT CHANGE
}
// ! ---------------------------------------------------------------------------

export function translateJapDocName(docName) {
  const list = {
    // tranquilidade
    notice: "Aviso Débito",
    greenCard: "Carta Verde",
    policyConditions: "Condições Particulares",
    generalConditions: "Condições Gerais",
    insuranceStatement: "Declaração de Seguro",
    productInformation: "Nota Informativa",
    temporaryCertificate: "Certificado Provisório",
    receipt: "Recibo",
    sepaDirectDebitMandate: "Autorização SDD",
    // mudum
    noticePayment: "Aviso de Pagamento",
    noticeTermination: "Aviso de Rescisão",
    greenCard: "Carta Verde",
    temporaryGreenCard: "Carta Verde Provisoria",
    generalConditions: "Condições Gerais",
    policyConditions: "Condições Particulares",
    creditor: "Declaração para Credor",
    dips: "DIPS",
    productInformation: "Ficha de Produto",
    proposal: "Proposta De  Subscrição",
    simulation: "Simulação",
    receipt: "Fatura / Recibo",
    renewalPolicy: "Aviso de nova Apólice / Aviso de Renovação",
  };

  return list[docName] || docName;
}

export const common_key_pair = {
  Sim: true,
  Não: false,
  Conjuge: "SPOUSE",
  "Filho(a)": "CHILDREN",
  Titular: "Titular",
  Masculino: "M",
  Feminino: "F",
  "Divorciado(a)": "DIVORCED",
  "Casado(a)": "MARRIED",
  "Separado(a)": "SEPARATED",
  "Viúvo(a)": "WIDOWED",
  "Solteiro(a)": "SINGLE",
  "/ano": "ANNUAL",
  "/mês": "MENSAL",
  "/semestre": "SEMESTRAL",
  "/trimestre": "TRIMESTRAL",
  OTHER: 'Outro',
  CHILD: 'Filho(a)',
  SPOUSE: 'Conjuge',
  POLICY_HOLDER: 'Tomador',
  ACTIVO: "ACTIVE",
  PENDENTE: "PENDING",
  CANCELADO: "CANCELLED",
  TERMINADO: "ENDED",
  EMITIDA: "ISSUED",
  "NÃO RENOVADO": "NOT_RENEWED",
  EXCLUÍDO: "DELETED",
  "Residência Permanente": "PERMANENT",
  "Segunda Habitação": "SECONDARY",
  "Alojamento Local": "LOCAL",
  Arrendamento: "RENTING",
  Desocupado: "UNOCCUPIED",
  Outro: "OTHER",
  "Referência Multibanco": "MBREFERENCE",
  "Débito Directo": "DIRECTDEBIT",
  Viagem: "TRAVEL",
  "Vida Crédito": "MORTGAGE",
  Carro: "CAR",
  Moto: "BIKE",
  Casa: "HOME",
  "AT Outrem": "DEPENDENT",
  "AT Indep.": "WORKACCIDENT",
  Outro: "OTHER",
  Saúde: "HEALTH",
  "Auto Empresas": "CARCOMPANIES",
  "AT Outrem": "WORKACCIDENTCOMPANIES",
  "Tempo Parcial": "PARTIALTIME",
  "Tempo inteiro": "FULLTIME"
};

export const PAYMENT_KEY = {
  único: "SINGLE",
  ano: "ANNUAL",
  semestre: "SEMESTER",
  trimestre: "QUARTERLY",
  mês: "MONTHLY",
  único: "ONETIME",
};

export const getImage = (value: string) => {
  return image[value];
};

export const getTranslatedValueCustom = (value, keyPair) => {
  return _.get(_.invert(keyPair), value, null);
};

export const getApiValueDeepCustom = (value, keyPair) => {
  return _.get(keyPair, value, null);
};

export const getApiValueCustom = (value, keyPair) => {
  return _.get(keyPair, value, null);
};

export function scrollToEmailError(isEmailCodeValid: any) {
  if (isEmailCodeValid == false) {
    const selector = `[name=email]`;
    const errorElement = document.querySelector(selector);
    if (errorElement) {
      errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    return true;
  } else {
    return false;
  }
}

export function scrollToCustomError(isCodeValid: any, fieldName: any) {
  if (isCodeValid == false) {
    const selector = `[name=${fieldName}]`;
    const errorElement = document.querySelector(selector);
    if (errorElement) {
      errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    return true;
  } else {
    return false;
  }
}

export const extractParams = (params: any, search: any) => {
  let paramsObject = {};

  for (let i = 0; i < params.length; i++) {
    paramsObject[params[i]] = new URLSearchParams(search).get(params[i]);
  }

  paramsObject["userId"] = paramsObject.overview;

  delete paramsObject.overview;

  return paramsObject;
};

// Like useImperativeQuery, but cache-first: a result already in the Apollo
// InMemoryCache for the same query + variables resolves instantly with no
// network request. refetch() always bypasses the cache, so this has to go
// through client.query instead of useQuery/refetch.
export const useCachedImperativeQuery = (query) => {
  const client = useApolloClient();

  return async (variables) => {
    const { data, errors } = await client.query({
      query,
      variables,
      fetchPolicy: "cache-first",
    });

    if (errors && errors.length > 0) {
      throw new Error(errors.map((e) => e.message).join(", "));
    }

    return { data, errors };
  };
};

export const useImperativeQuery = (query) => {
  const history = useHistory();
  const proId = useSelector((state) => state?.userData?.partnerId);

  const { refetch } = useQuery(query, {
    skip: true,
    fetchPolicy: "no-cache",
  });

  const imperativelyCallQuery = async (variables) => {
    try {
      const { data, errors } = await refetch(variables);

      if (errors && errors.length > 0) {
        throw new Error(errors.map((e) => e.message).join(", "));
      }

      return new Promise((resolve) => resolve({ data, errors }));
    } catch (err) {
      // Some paths go down apiErrorHandler to handle this, same logic was applied there
      if (_.includes(err, 'Este link expirou após alguns dias de inatividade')) {
        Swal.fire("A tua simulação já expirou. Vamos começar novamente")
        .then(
          () => {
            const urlPath = location.pathname.split("/")[1];

            return history.push(`/${urlPath}/simulacao?proId=${proId}`);
          }
        );
      }

      throw err;
    }
  };

  return imperativelyCallQuery;
};

export const convertToFormatNumber = (
  value,
  hasSymbol = false,
  hasSlash = false,
  customSymbol = false
) => {
  return `${new Intl.NumberFormat("de-DE", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(value)} ${hasSymbol ? "€" : ""} ${hasSlash ? "/" : ""} ${
    customSymbol ? customSymbol : ""
  }`;
};

export const getFieldErrorNames = (formikErrors: any) => {
  const transformObjectToDotNotation = (
    obj: any,
    prefix: any = "",
    result: any = []
  ) => {
    for (const key in obj) {
      if (!obj.hasOwnProperty(key)) continue;

      const value = obj[key];
      if (!value) continue;

      const nextKey = prefix ? `${prefix}[${key}]` : key;
      if (typeof value === "object") {
        transformObjectToDotNotation(value, nextKey, result);
      } else {
        result.push(nextKey);
      }
    }
    return result;
  };

  return transformObjectToDotNotation(formikErrors);
};

export function getSectionFormHeadingData(sectionQuestions, formValues, objTranslate, badge = 0) {
  if (!sectionQuestions || !formValues) return;

  return sectionQuestions?.map((sectionQuestion) => {
    const { question } = sectionQuestion;
    let value;

    // must have value or a reference to get the value
    if (formValues[sectionQuestion.name] == null && !sectionQuestion.apiKey) {
      /* if (badge === 5) {
        console.log("-> C");
        console.log("sectionQuestion.name:", sectionQuestion.name)
        console.log("formValues[sectionQuestion.name]:", formValues[sectionQuestion.name])
        console.log("formValues:", formValues)
      } */

      return;
    }

    // tries to find question value based in obj path string
    if (sectionQuestion.apiKey) {
      if (_.get(formValues, sectionQuestion.apiKey) == null) {

        return;
      }

      value = _.get(formValues, sectionQuestion.apiKey);
    } else if (sectionQuestion.translate) {

      value = getTranslatedValueCustom(formValues[sectionQuestion.name], objTranslate);
    } else if (sectionQuestion.isCheckBox && sectionQuestion.isConsent) {

      return { question: sectionQuestion.labelText };
    } else {

      value = formValues[sectionQuestion.name];
    }

    if (question === "Profissão") {
      value = formValues.profession;
    }

    return { question, value };
  });
}

export const getProfessionObj = (data: any) => {
  return data.map((item: any) => {
    return { label: item, value: item };
  });
};

export const getCustomerObj = (data: any) => {
  const customerData = data?.map((item: any) => {
    return {
      label: item.customerName + "_" + item.customerNif,
      value: item.customerName + "_" + item.customerNif,
      ...item,
    };
  });
  customerData.unshift({
    value: "Adicionar novo cliente",
    label: "Adicionar novo cliente",
  });
  return customerData;
};

export const convertDateFormat = (date) => {
  if (date) {
    if (isValidDate(date)) {
      return date;
    } else return moment(date)?.format("DD-MM-YYYY");
  } else {
    return null;
  }
};

export const insuranceDateFormat = (date) => {
  return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
};

export const getQuestionsAnsJourney = ( question, values, keyPair, filters = [] ) => {
  if (_.isPlainObject(values) && question) {

    return question
    .filter((item: any) => !_.includes(filters, item?.name))
    .map((item) => {
      const data = _.get(values, item.name, null);
      if (data === null) {
        return null;
      }

      return {
        question: item.question,
        answer: getAnswer(item, values, keyPair),
      };
    });
  }
};

const getAnswer = (item, values, keyPair) => {
  const data = _.get(values, item.name, null);

  if (item.isInnerKey){
    return getTranslatedValueCustom(data, keyPair[item.name]);
  }

  if (item.translate) {
    return getTranslatedValueCustom(data, keyPair);
  }

  if (item.arrayTranslate){
    return _.join( _.map(data, (item) => getTranslatedValueCustom(item, keyPair)), " , ");
  }

  if (item.arrayDates){
    return _.join(data, ', ');
  }

  if (item.isPrice) {
    return `${data}€`;
  }

  return data;
};

export function isValidDate(dateString, dateFormat = "DD-MM-YYYY") {
  return moment(dateString, dateFormat, true).isValid();
}

export function validateBirthdate(birthdate) {
  let formattedDate = null;
  const formats = [
    "DD-MM-YYYY",
    "MM-DD-YYYY",
    "YYYY-MM-DD",
    "YYYY/MM/DD",
    "YYYY-MM-DDTHH:mm:ss.SSSZ",
  ];

  const formattedBirthdate = formats
    .map((format) => moment(birthdate, format, true).format("DD-MM-YYYY"))
    .find((date) => moment(date, "DD-MM-YYYY", true).isValid());
  const birthdateNew = moment(formattedBirthdate, "DD-MM-YYYY", true);
  if (birthdateNew.isValid()) {
    formattedDate = formattedBirthdate;
  }
  return formattedDate; // This will return null if the date doesn't match either format.
}

export function validateMobile(value) {
  if (value) {
    const newValue = value.replace(/\s+/g, "");
    return validator.isMobilePhone(newValue, "pt-PT", { strictMode: true });
  } else {
    return false;
  }
}

export function validateCustomerObject(customerObject) {
  // Validation for customerBirthdate
  if (customerObject.customerBirthdate) {
    customerObject.customerBirthdate = validateBirthdate(
      customerObject.customerBirthdate
    );
  }

  if (customerObject.customerPhone) {
    const isValidMobile = validateMobile(customerObject.customerPhone);
    if (!isValidMobile) {
      customerObject.customerPhone = null;
    }
  }
  // Return the updated object
  return customerObject;
}

export function validateDate(date) {
  let formattedDate = null;
  const formats = [
    "DD-MM-YYYY",
    "MM-DD-YYYY",
    "YYYY-MM-DD",
    "YYYY/MM/DD",
    "YYYY-MM-DDTHH:mm:ss.SSSZ",
  ];

  const formattedDateNew = formats
    .map((format) => moment(date, format, true).format("DD-MM-YYYY"))
    .find((date) => moment(date, "DD-MM-YYYY", true).isValid());
  const dateNew = moment(formattedDateNew, "DD-MM-YYYY", true);
  if (dateNew.isValid()) {
    formattedDate = formattedDateNew;
  }
  return formattedDate; // This will return null if the date doesn't match either format.
}

export const gotToPolicyDetails = ({ type, policyId, history }) => {
  const insuranceType = _.toUpper(type);

  if (!insuranceType || !policyId) {
    return;
  }

  history.push(`/apolice-detalhes?policyId=${policyId}&type=${insuranceType}`);
};

export function removeSpaces(inputString) {
  return inputString?.replace(/\s/g, "");
}

export function nifLabel(nif) {
  const value = String(nif || "").trim();
  return value ? `NIF ${value}` : "";
}

// customerReference keeps the "<name>_<nif>" format because the NIF filter searches it.
export function splitCustomerReference(reference) {
  const [, name = reference, nif = ""] = /^(.*)_([\d\s]*)$/.exec(reference || "") || [];
  return { name, nif: nif.trim() };
}

export function getContrastColor(hex) {
  if (!hex) return 'black';
  hex = hex.replace(/^#/, '');

  if (hex.length === 3) {
    // Expand shorthand #RGB to full form
    hex = hex.split('').map(c => c + c).join('');
  }

  if (hex.length !== 6 && hex.length !== 8) {
    throw new Error('Invalid hex format. Expected #RGB, #RRGGBB, or #RRGGBBAA');
  }

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  const hasAlpha = hex.length === 8;
  const a = hasAlpha ? parseInt(hex.slice(6, 8), 16) / 255 : 1;

  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // This function can be changed to give the colors a bit of blend, instead of plain black and white.
  return a < 0.5
    ? 'black' // High alpha values (that blend a lot) will always return black.
    : brightness > 128
      ? 'black'
      : 'white'
}

import MGEN from '~images/icons/insurers_logos/mgen.png';
import OCIDENTAL from '~images/icons/insurers_logos/ocidental.png';
import FIDELIDADE from '~images/icons/insurers_logos/fidelidade.png';
import VICTORIA from '~images/icons/insurers_logos/victoria.png';
import TRANQUILIDADE from '~images/icons/insurers_logos/tranquilidade.png';
import REALVIDA from '~images/icons/insurers_logos/real_vida.png';
import SAUDEPRIME from '~images/icons/insurers_logos/saudeprime.png';
import PREVOIR from '~images/icons/insurers_logos/prevoir.png';
import MAPFRE from '~images/icons/insurers_logos/mapfre.png';
import ALLIANZ from '~images/icons/insurers_logos/allianz.png';
import ASISA from '~images/icons/insurers_logos/asisa.png';
import LUSITANIA from '~images/icons/insurers_logos/lusitania.png';

export function getImageFromPartnerName(Name) {
  
  const Providers = {
    MGEN: MGEN,
    OCIDENTAL: OCIDENTAL,
    FIDELIDADE: FIDELIDADE,
    VICTORIA: VICTORIA,
    TRANQUILIDADE: TRANQUILIDADE,
    REALVIDA: REALVIDA,
    SAUDEPRIME: SAUDEPRIME,
    PREVOIR: PREVOIR,
    MAPFRE: MAPFRE,
    ALLIANZ:ALLIANZ,
    ASISA: ASISA,
    LUSITANIA: LUSITANIA
  }

  return Providers[Name];
}

export function checkForMatch(keywords, text) {
  const foundMatch = keywords.some(keyword => text.includes(keyword));

  return foundMatch;
}
